import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  ArquivoModel,
  ArquivosRodapeModel,
  ArquivosTermosCompromissoModel,
  TermoCompromissoTestTemplateModel,
} from '@shared/models/backend'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class ArquivosSistemaService {
  constructor(private http: HttpClient) {}

  getArquivoFaq(): Observable<ArquivoModel> {
    return this.http.get<ArquivoModel>('/api/public/arquivos-sistema/faq').pipe(take(1))
  }

  getArquivoManual(): Observable<ArquivoModel> {
    return this.http.get<ArquivoModel>('/api/public/arquivos-sistema/manual').pipe(take(1))
  }

  getArquivoTermoMedica(): Observable<ArquivoModel> {
    return this.http.get<ArquivoModel>('/api/arquivos-sistema/termo-compromisso-medica').pipe(take(1))
  }

  getArquivoTermoAreaProfissional(): Observable<ArquivoModel> {
    return this.http.get<ArquivoModel>('/api/arquivos-sistema/termo-compromisso-area-profissional').pipe(take(1))
  }

  getArquivosModeloInstitucional(): Observable<ArquivoModel[]> {
    return this.http.get<ArquivoModel[]>('/api/public/arquivos-sistema/modelos-institucionais').pipe(take(1))
  }

  saveArquivosRodape(data: ArquivosRodapeModel) {
    return this.http.post('/api/arquivos-sistema/rodape', data).pipe(take(1))
  }

  saveArquivosTermos(data: ArquivosTermosCompromissoModel) {
    return this.http.post('/api/arquivos-sistema/termo-compromisso', data).pipe(take(1))
  }

  downloadTesteTermoCompromisso(data: TermoCompromissoTestTemplateModel) {
    return this.http
      .post('/api/arquivos-sistema/termo-compromisso/download-teste', data, {
        responseType: 'blob',
      })
      .pipe(take(1))
  }

  deleteArquivoRodape(idArquivo: number) {
    return this.http.delete(`/api/arquivos-sistema/rodape/${idArquivo}`).pipe(take(1))
  }
}
